var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "padTXM padBXM txtC",
        staticStyle: {
          background:
            "url(https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/bg.jpg) no-repeat  center / cover",
          color: "#fff"
        }
      },
      [
        _c("div", [
          _c("img", {
            staticStyle: {
              "max-width": "200px",
              "min-width": "116px",
              width: "30%"
            },
            attrs: {
              src:
                "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/logo_artistry_skin_nutrition_white.png",
              alt: "Artistry Skin Nutrition(로고)"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "marTML fntH1 fntM",
            staticStyle: { "line-height": "1.15" }
          },
          [
            _c("em", { staticClass: "light" }, [
              _vm._v("스킨 뉴트리션 "),
              _c("br"),
              _vm._v("리뉴잉 & 퍼밍 출시 기념")
            ]),
            _c("br"),
            _vm._v(" "),
            _c("b", { staticClass: "bold" }, [_vm._v("깜짝 이벤트")])
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _c("img", {
            attrs: {
              src:
                "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/vis.png",
              alt: "스킨 뉴트리션 퍼밍 울트라 리프팅 크림 제품 이미지"
            }
          })
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "marTS fntH6" }, [
          _vm._v("\n          지금 이벤트에 참여하여 "),
          _c("br", { staticClass: "moOnly" }),
          _vm._v("\n          스킨 뉴트리션 퍼밍 울트라 리프팅 크림을 "),
          _c("br"),
          _vm._v("\n          가장 먼저 체험해 보세요.\n      ")
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68102f06", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68102f06","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/waste-glass-bottle2/component/header.vue
// module id = null
// module chunks = 